import { FormEvent, useEffect, useRef, useState } from 'react';
import { ReactComponent as SearchIcon } from 'assets/icons/search.svg';
import { colors } from 'constants/styles/colors';

interface ISearchInput {
  onChangeQuery?: (query: string) => void;
  placeholder?: string;
  ariaLabel?: string;
}

const SearchFilter: React.FC<ISearchInput> = ({ onChangeQuery, placeholder, ariaLabel }) => {
  const [value, setValue] = useState('');
  const debounceRef = useRef<number | null>(null);
  const lastEmittedRef = useRef<string>('');
  const DEBOUNCE_MS = 300;

  const handleSearchInput = (e: FormEvent<HTMLInputElement>): void => {
    setValue(e.currentTarget.value);
  };

  const onSearchSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!onChangeQuery) return;
    if (debounceRef.current) {
      window.clearTimeout(debounceRef.current);
    }
    lastEmittedRef.current = value;
    onChangeQuery(value);
  };

  useEffect(() => {
    if (!onChangeQuery) return undefined;
    if (debounceRef.current) {
      window.clearTimeout(debounceRef.current);
    }
    debounceRef.current = window.setTimeout(() => {
      if (lastEmittedRef.current === value) return;
      lastEmittedRef.current = value;
      onChangeQuery(value);
    }, DEBOUNCE_MS);
    return () => {
      if (debounceRef.current) {
        window.clearTimeout(debounceRef.current);
      }
    };
  }, [value, onChangeQuery]);

  return (
    <form
      className="col input-group input-group-solid align-items-center ps-4 rounded"
      onSubmit={onSearchSubmit}
      style={{
        backgroundColor: colors.body.bg,
        flexGrow: 1,
        borderRadius: '12px',
        minHeight: '46px',
      }}
    >
      <SearchIcon />
      <input
        type="text"
        className="form-control"
        placeholder={placeholder || 'Search'}
        aria-label={ariaLabel || 'search'}
        aria-describedby="basic-search"
        onChange={handleSearchInput}
        value={value}
        style={{ backgroundColor: 'transparent', border: 'none', boxShadow: 'none' }}
      />
    </form>
  );
};

export default SearchFilter;
